import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { initMessageListener } from 'redux-state-sync';

import { inventoryReduces } from '../components/ProjectManagement/Inventory/reducers';

import {
  routeConfigReducer,
  userReducer,
  userFormReducer,
  userManagementReducer,
  userFormDetailsReducer,
  userFormDashboardsReducer,
  userFormCoverageReducer,
  userFormContactReducer,
  userFormAddressReducer,
  userFormLicenseReducer,
  userFormTeamReviewReducer,
  userFormDocumentsReducer,
  userFormCredentialsReducer,
  userFormAvailabilityReducer,
  permissionsListReducer,
  userFormRoutingReducer,
  assignWidgetsReducer,
  newSchedulerReducer,
  routeMapSliceReducer,
  pageHeaderReducer,
  installerViewCalendarReducer,
  quoteHeaderReducer,
  phoneTypeReducer,
  stateMasterReducer,
  industryTypesReducer,
  projectTypesReducer,
  projectCategoryReducer,
  warrantyConfigReducer,
  opportunitySourceReducer,
  opportunityStatusReducer,
  quoteStatusReducer,
  invoiceItems,
  userFormCrewReducer,
  userFormCrewMemberReducer,
  measureSquareConfigReducer,
  questionnaireReducer,
  typeReducer,
  techniciansReducer,
  categoriesReducer,
  projectStoresReducer,
  projectAllStoresReducer,
  districtsReducer,
  userTypesReducer,
  workroomsReducer,
  installerWorkTypeReducer,
  sourceStatusTypeReducer,
  projectStatusTypeReducer,
  quoteStatusTypeReducer,
  viewMoreEventReducer,
  schedulerTechnicianViewReducer,
  techniciansLimitReducer,
  sourceSystemReducer,
  projectNotesSliceReducer,
  uploadVideoPhotoReducer,
  hdDocsReducer,
  taskNotificationReducer,
  territoryReducer,
  userCategoryReducer,
  userSkillLevelReducer,
  supportStatusesReducer,
  supportTypesReducer,
  supportPrioritiesReducer,
  supportTicketCreatorsReducer,
  supportClientsReducer,
  supportTenantUsersReducer,
  siteAddressReducer,
  defaultColorReducer,
} from './slices';
import { globalFiltersSliceReducer } from './slices/globalFilters.slice';
import { leadJobPopUpReducer } from './slices/LeadJobPopup.slice';
import { projectLayoutConfigReducer } from './slices/projectLayoutConfig.slice';
import { userProfile } from './slices/userProfile.slice';
import { crmApi } from './api/crmApi';
import { inventoryApi } from './api/inventoryApi';
import { orderCountFiltersReducer } from './slices/countOfOrder.slice';
import { incomingSmsFiltersReducer } from './slices/countOfIncomingSms.slice';
import { outgoingSmsFiltersReducer } from './slices/countOfOutgoingSms.slice';
import { tenantReportReducer } from './slices/tenantReport.slice';
import { tableConfigurationReducer } from './slices/tableConfiguration.slice';
import { projectDetailsReducer } from './slices/projectDetails.slice';
import { municipalityRegistrationReducer } from './slices/municipalityRegistration.slice';
import { entityLayoutConfigReducer } from './slices/entityLayoutsConfig.slice';

const rootReducer = combineReducers({
  user: userReducer,
  routeConfig: routeConfigReducer,
  userForm: userFormReducer,
  userManagement: userManagementReducer,
  userFormDetails: userFormDetailsReducer,
  userFormDashboards: userFormDashboardsReducer,
  userFormCoverage: userFormCoverageReducer,
  userFormContact: userFormContactReducer,
  userFormAddress: userFormAddressReducer,
  userFormLicense: userFormLicenseReducer,
  userFormTeamReview: userFormTeamReviewReducer,
  userFormDocuments: userFormDocumentsReducer,
  userFormCredentials: userFormCredentialsReducer,
  userFormAvailability: userFormAvailabilityReducer,
  permissionsList: permissionsListReducer,
  userFormRouting: userFormRoutingReducer,
  assignWidgets: assignWidgetsReducer,
  newScheduler: newSchedulerReducer,
  inventoryManagment: combineReducers(inventoryReduces),
  routeMap: routeMapSliceReducer,
  pageHeader: pageHeaderReducer,
  installerViewCalendar: installerViewCalendarReducer,
  quoteHeader: quoteHeaderReducer,
  userFormCrew: userFormCrewReducer,
  userFormCrewMember: userFormCrewMemberReducer,
  masters: combineReducers({
    phoneTypeReducer,
    stateMasterReducer,
    industryTypesReducer,
    projectTypesReducer,
    projectCategoryReducer,
    opportunitySourceReducer,
    opportunityStatusReducer,
    quoteStatusReducer,
  }),
  warrantyConfig: warrantyConfigReducer,
  crm: combineReducers({ projectInvoice: invoiceItems }),
  measureSquareConfig: measureSquareConfigReducer,
  questionnaire: questionnaireReducer,
  types: typeReducer,
  technicians: techniciansReducer,
  categories: categoriesReducer,
  projectStores: projectStoresReducer,
  projectAllStores: projectAllStoresReducer,
  districts: districtsReducer,
  userTypes: userTypesReducer,
  workrooms: workroomsReducer,
  installerWorkType: installerWorkTypeReducer,
  sourceStatusType: sourceStatusTypeReducer,
  projectStatusType: projectStatusTypeReducer,
  quoteStatusType: quoteStatusTypeReducer,
  viewMoreEventDropdown: viewMoreEventReducer,
  globalFilters: globalFiltersSliceReducer,
  schedulerTechnicianView: schedulerTechnicianViewReducer,
  techniciansLimitList: techniciansLimitReducer,
  sourceSystems: sourceSystemReducer,
  projectNotes: projectNotesSliceReducer,
  leadJobPopUp: leadJobPopUpReducer,
  projectLayoutConfig: projectLayoutConfigReducer,
  uploadVideoPhoto: uploadVideoPhotoReducer,
  hdDocs: hdDocsReducer,
  taskNotification: taskNotificationReducer,
  userProfile: userProfile,
  orderCountFilters: orderCountFiltersReducer,
  countOfIncomingSms: incomingSmsFiltersReducer,
  countOfOutgoingSms: outgoingSmsFiltersReducer,
  tenantReport: tenantReportReducer,
  tableConfiguration: tableConfigurationReducer,
  municipalityRegistration: municipalityRegistrationReducer,
  territoryList: territoryReducer,
  userCategoryList: userCategoryReducer,
  userSkillLevelList: userSkillLevelReducer,
  support: combineReducers({
    statuses: supportStatusesReducer,
    types: supportTypesReducer,
    priorities: supportPrioritiesReducer,
    ticketCreators: supportTicketCreatorsReducer,
    clients: supportClientsReducer,
    tenantUsers: supportTenantUsersReducer,
  }),
  [crmApi.reducerPath]: crmApi.reducer,
  [inventoryApi.reducerPath]: inventoryApi.reducer,
  siteAddresses: siteAddressReducer,
  projectDetails: projectDetailsReducer,
  defaultColors: defaultColorReducer,
  entityLayoutConfig: entityLayoutConfigReducer,
});
export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(crmApi.middleware, inventoryApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

initMessageListener(store);
